import React from 'react';
import api from '../services/api';
import './RetrieveMentoringData.css'; 
class RetrieveMentoringData extends React.Component {
  constructor(props) {
    super(props);    
    this.state = {content: "Carregando..."}    
  }
  componentDidMount(){    
    api.getMentoringData().then((rs) => {        
        this.setState({content:rs.response});        
      })
      .catch((error) => {        
        console.error(error);
      });      
  }
  render(){    
    var content = this.state.content; 
    return (      
      <div className="mentoring-data-main">
        <h1>Dados de mentoria (CSV)</h1>
        <textarea rows="25" value={content}  />                
      </div>      
    )
    }
};

export default RetrieveMentoringData;


// WEBPACK FOOTER //
// ./src/pages/RetrieveMentoringData.js